// Format role name
export const formatRole = (role: string): string => {
  const roleMap: Record<string, string> = {
    admin: 'Administrador',
    coordinator: 'Coordinador',
    teacher: 'Profesor',
    student: 'Estudiante',
  };
  return roleMap[role] || role;
};

// Get user full name
export const getUserFullName = (user: { first_name: string; last_name: string }): string => {
  return `${user.first_name} ${user.last_name}`.trim();
};

// Get user initials
export const getUserInitials = (user: { first_name: string; last_name: string }): string => {
  const firstInitial = user.first_name.charAt(0).toUpperCase();
  const lastInitial = user.last_name.charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
};

// Format phone number
export const formatPhone = (phone: string): string => {
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as (XXX) XXX-XXXX
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  return phone;
};
